package com.parmartechnologies.core.feature.notification.model

import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@Serializable
data class Notification @OptIn(ExperimentalTime::class) constructor(
    @SerialName("user_id") var UserID: String = "",
    @SerialName("_id") var _id: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("fcm_token") var FCMToken: String = "",
    @SerialName("email_id") var emailID: String = "",
    @SerialName("Title") var title: String = "",
    @SerialName("message") var message: String = "",
    @SerialName("payload") var payload: NotificationPayload? = null,
    @SerialName("notification_type") var notificationType: String = "",
    @SerialName("device_id") var deviceID: String = "",
    @SerialName("image") var image: String = "",
    @SerialName("is_sent") var isSent: Int = 0,
    @SerialName("is_read") var isRead: Int = 0,
    @SerialName("is_deleted") var IsDeleted: Int = 0,
    @SerialName("created_at") val CreatedAt: LocalDateTime = Clock.System.now().toLocalDateTime(
        TimeZone.UTC),
    @SerialName("updated_at") val UpdatedAt: LocalDateTime = Clock.System.now().toLocalDateTime(
        TimeZone.UTC),
    @SerialName("__v") var _v: Int = 0
)

@Serializable
data class NotificationPayload @OptIn(ExperimentalTime::class) constructor(
    @SerialName("unique_id") var UniqueId: Long = Clock.System.now().epochSeconds,
    @SerialName("_id") var _id: String = "",
    @SerialName("feature_object_id") var featureObjectID: String = "",
    @SerialName("from_user_id") var fromUserID: String = "",
    @SerialName("to_user_id") var toUserID: String = "",
    @SerialName("from_business_id") var fromBusinessID: String = "",
    @SerialName("to_business_id") var toBusinessID: String = "",
    @SerialName("name") var name: String = "",
)